import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Row, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useSalesTrackingGenderBrand from '../useSalesTrackingsGenderBrand';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    filters,
    title,
    loading,
    handleDownloadExcel,
    searchParams,
    format,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useSalesTrackingGenderBrand();
  const { t } = useTranslation();

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={'SALES TRACKING: brand/gender'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage
          errors={errors}
          shopRequired={true}
          searchParams={searchParams}
        />
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <BarChangeChart
                  keys={['Gender']}
                  data={data.chart1}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideLine
                />
              </Col>
              <Col span={12}>
                <BarChangeChart
                  keys={['Gender']}
                  data={data.chart2}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideLine
                />
              </Col>
              <Col span={12}>
                <BarChangeChart
                  keys={['Maschi', 'Femmine']}
                  data={data.chart3}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideLine
                />
              </Col>
              <Col span={12}>
                <BarChangeChart
                  keys={['Maschi', 'Femmine']}
                  data={data.chart4}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideLine
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
